export default {
  thisBaseOn: 'This is based on',
  baseOnL18n: 'The internationalization of this project is based on',
  baseOn: 'is based on',
  documentation: 'Documentation',
  palette: 'You can generate your palette on',
  theme: 'Choose a color scheme:',
  dropHere: 'Drop files here to upload',
  tinymceTips: 'Online rich-text editor released as open-source software under the LGPL.',
  imageUploadTips: 'Modified. If you are going to use it, it is better to use official version.',
  dropzoneTips: '',
  stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
  backToTop: 'When the page is scrolled to the specified position, '
    + 'the Back to Top button appears in the lower right corner',
  draggable: 'Allows you to drag and panel and items inside',
};
